module.exports = "<div class=\"panel flex-column gt-xs align-bottom\" ng-class=\"{'full-screen': $ctrl.fullScreen}\" background-image=\"{{$ctrl.image}}\" speed=\"$ctrl.speed\">\r\n\t<div class=\"panel-content\" ng-class=\"$ctrl.fullScreen ? 'flex flex-column align-middle' : 'flex-row gt-xs'\">\r\n\t\t<div class=\"panel-title\" ng-transclude=\"title\"></div>\r\n\t\t<div class=\"panel-body\" ng-transclude=\"body\"></div>\r\n\t</div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/panel.html
 ** module id = 26
 ** module chunks = 0
 **/